var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { spacingCss } from "../global/css";
var responsiveStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 30px;\n  height: 30px;\n\n  ", "\n\n  ", "\n"], ["\n  width: 30px;\n  height: 30px;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 50px;\n    height: 50px;\n  "], ["\n    width: 50px;\n    height: 50px;\n  "])));
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100px;\n    height: 100px;\n  "], ["\n    width: 100px;\n    height: 100px;\n  "])));
});
export var Pic = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  ", "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n\n  ",
    "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return !size && responsiveStyles;
}, function (_a) {
    var size = _a.size;
    return size && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), typeof size === "string" ? size : size + "px", typeof size === "string" ? size : size + "px");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var color = _a.color;
    return color && "background-color: " + color + ";";
}, function (_a) {
    var theme = _a.theme, border = _a.border;
    return border && "border: 2px solid " + theme.colors.greys.white + ";";
}, spacingCss);
export var Img = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n\n  ",
    "\n  ", "\n  ",
    "\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return !size && responsiveStyles;
}, function (_a) {
    var size = _a.size;
    return size && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), typeof size === "string" ? size : size + "px", typeof size === "string" ? size : size + "px");
}, function (_a) {
    var deactivated = _a.deactivated;
    return deactivated && "filter: grayscale(100%);";
}, function (_a) {
    var theme = _a.theme, border = _a.border;
    return border && "\n    border: 2px solid " + theme.colors.greys.white + ";\n    border-radius: 100%;\n  ";
}, function (_a) {
    var theme = _a.theme, marginRight = _a.marginRight;
    return marginRight && "margin-right: " + theme.spacing.one + ";";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
